// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nhlb","tabsBox":"styles_tabsBox__22Be7","createButton":"styles_createButton__2rin6"};